export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13546.d868c821.jpg";